import PropTypes from 'prop-types';

const CreateGroupPropType = {
  enableRightDrawer: PropTypes.func.isRequired,
};

export default CreateGroupPropType;
